<section>
  <section>
    <div class="container">
      <div class="row">
        <div class="col-12">
          <div class="modal fade" id="selectpg-popup" tabindex="-1">
            <div class="modal-dialog modal-xl modal-dialog-centered">
              <div class="modal-content client-selector-modal">
                <div class="modal-header">
                  <h3 class="modal-title">Select the Client</h3>
                </div>

                <div class="modal-body">
                  <div class="search-bar-wrapper d-flex align-items-center gap-2 mb-3">
                    <input
                      type="text"
                      class="form-control search-input"
                      placeholder="Search"
                      [(ngModel)]="searchText"
                      (input)="searchCompanies()" />
                    <button
                      type="button"
                      class="clear-selection-btn text-nowrap"
                      aria-label="Clear selected client"
                      [class.invisible]="!hasSelection"
                      [disabled]="!hasSelection"
                      (click)="clearSelection()">
                      CLEAR
                    </button>
                  </div>

                  <div class="btnpopdv text-end mb-3">
                    <button type="button" class="btn-popup-transparent" (click)="close()">CANCEL</button>
                    <button type="button" class="btn-popup-color" (click)="submit()">SUBMIT</button>
                  </div>

                  <div class="client-scroll">
                    <div class="client-list" #dropdown>
                      <div class="group-block" *ngFor="let group of groupedOptions">
                        <div
                          class="group-row"
                          [class.disabled]="group.group.disabled"
                          (click)="!group.group.disabled && toggleOption(group.group)">
                          <input type="checkbox" [checked]="group.group.selected" [disabled]="group.group.disabled" />
                          <span class="icon">🌐</span>
                          <span class="label" [class.disabled]="group.group.disabled">{{ group.group.value }}</span>
                          <span
                            class="expand-icon"
                            [style.transform]="group.expanded ? 'rotate(90deg)' : 'rotate(0deg)'"
                            (click)="toggleGroup(group, $event)">
                            ▶
                          </span>
                        </div>

                        <div class="entity-grid-wrapper" [class.expanded]="group.expanded">
                          <div class="entity-grid">
                            <div
                              class="entity-row"
                              [class.disabled]="company.disabled"
                              *ngFor="let company of group.entities"
                              (click)="!company.disabled && toggleOption(company)">
                              <input type="checkbox" [checked]="company.selected" [disabled]="company.disabled" />
                              <span class="icon">🏢</span>
                              <span class="label" [class.disabled]="company.disabled">{{ company.value }}</span>
                            </div>
                          </div>
                        </div>
                      </div>

                      <div class="entity-grid" *ngIf="ungroupedEntities.length > 0">
                        <div
                          class="entity-row"
                          [class.disabled]="company.disabled"
                          *ngFor="let company of ungroupedEntities"
                          (click)="!company.disabled && toggleOption(company)">
                          <input type="checkbox" [checked]="company.selected" [disabled]="company.disabled" />
                          <span class="icon">🏢</span>
                          <span class="label" [class.disabled]="company.disabled">{{ company.value }}</span>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div
                    *ngIf="clientFormControl && clientFormControl.errors && clientFormControl.touched"
                    class="invalid-feedback d-block mt-2">
                    <div *ngIf="clientFormControl.errors.required">This is mandatory field, Kindly select client</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</section>
